var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-panel"},[_c('div',{staticClass:"content"},[(_vm.showFileComponent)?_c('CloudFiles',{attrs:{"path":"Root","tenantId":_vm.tenantId},on:{"restart":_vm.restart}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }